import styled from "styled-components";

export const Container = styled.div``;

export const AreaActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;
